import type { AnalyticsDataSource, DateRange, QueryFilters } from '../types/analytics';
import type { AnalyticsSectionId, ExportSection } from './exportTypes';
import { sectionOrder } from './exportTypes';

export async function loadExportSection(source: AnalyticsDataSource, id: AnalyticsSectionId, range: DateRange, filters?: QueryFilters): Promise<ExportSection> {
  switch (id) {
    case 'overview': return { id, envelope: await source.getOverview(range, undefined, filters) };
    case 'acquisition': return { id, envelope: await source.getAcquisition(range, undefined, filters) };
    case 'activation': return { id, envelope: await source.getActivationFunnel(range, undefined, filters) };
    case 'retention': return { id, envelope: await source.getRetention(range, undefined, filters) };
    case 'features': return { id, envelope: await source.getFeatureUsage(range, undefined, filters) };
    case 'receipts': return { id, envelope: await source.getReceiptMetrics(range, undefined, filters) };
    case 'price-comparison': return { id, envelope: await source.getPriceComparisonMetrics(range, undefined, filters) };
    case 'costs': return { id, envelope: await source.getCostMetrics(range, undefined, filters) };
    case 'reliability': return { id, envelope: await source.getSystemHealth(range, undefined, filters) };
  }
}

export function loadFullExport(source: AnalyticsDataSource, range: DateRange, filters?: QueryFilters): Promise<ExportSection[]> {
  return Promise.all(sectionOrder.map((id) => loadExportSection(source, id, range, filters)));
}
